import * as yup from 'yup';
import {
    emailIdSchema,
    usernameSchema,
} from './common';

export const forgotPasswordSchema = yup.object().shape({
    username: yup
        .string()
        .required('Enter username')
        .matches('^[a-zA-Z0-9_]*$', 'User Name should not contain spaces'),
    emailId: emailIdSchema,
});
